<script setup>
    import { ref,  watch, reactive } from 'vue';
    import gsap from "gsap/gsap-core";

    const props = defineProps({
        value: {
            default: 0,
            Required: true,
        },

        decimals: {
            type: Number,
            default: 0,
        },

        suffix: {
            type: String,
            default: null,
        },
    });

    const tweenValue = reactive({
        number: props.value,
    });

    const tweenTest = ref(props.value)
    
    const displayValue = ref(props.value);

    watch(() => props.value, (newVal) => {
        gsap.to(tweenValue, { 
            number: newVal, 
            duration: 0.5,
            onUpdate: () => {
                displayValue.value = Number(tweenValue.number.toFixed(props.decimals));
            }
        });
    });
</script>

<template>
    {{ displayValue }} {{ props.suffix }}
</template>